export default class VirtualBrand {
	name: string;

	constructor(name: string) {
		this.name = name;
	}
}
